import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IGqlBaseOptions } from 'src/app/shared/modules/graphql/interfaces';
import { ListPage } from 'src/app/shared/helpers/list-page.class';
import { GqlInvestigationMetricsStateService } from 'src/app/shared/modules/graphql/services';
import { IApiInvestigationMetricsFilter, IApiInvestigationMetricsStateConnection } from 'src/app/shared/modules/graphql/types/types';

@Injectable()
export class InvestigationMetricsStateService {
  constructor(
    private gqlInvestigationMetricsStateService: GqlInvestigationMetricsStateService
  ) { }

  public get(filters?: IApiInvestigationMetricsFilter[], options?: IGqlBaseOptions): Observable<IApiInvestigationMetricsStateConnection> {
    return this.gqlInvestigationMetricsStateService.get(filters, options || new ListPage());
  }

}
